<script setup>
import { Dialog } from 'quasar'
import { getI18n } from '@/plugins/i18n'
import { ref } from 'vue'

import { useCamera } from '@/composables/camera'
import { useDetectDevice } from '@/composables/device'
import ImageCropDialog from '@/components/shared/ImageCropDialog.vue'

const props = defineProps({
  editItem: { type: Object, required: true }
})

const i18n = getI18n()
const { isMobile } = useDetectDevice()
const { readImageAsync, applyImage } = useCamera()

const cameraInput = ref(null)
const galleryInput = ref(null)
const sourceImage = ref(null)
const sourceName = ref(null)

const onActivateCamera = () => {
  if (!isMobile.value) {
    galleryInput.value.click()
    return
  }
  Dialog.create({
    message: i18n.t('info.cameraOrGallery'),
    ok: i18n.t('common.camera'),
    cancel: i18n.t('common.gallery'),
    persistent: true,
  }).onOk(() => cameraInput.value.click())
   .onCancel(() => galleryInput.value.click())
}

const onFileSelected = async(event) => {
  const image = await readImageAsync(event)
  if (!image) return
  sourceName.value = image.name
  sourceImage.value = image.dataUrl
}

const onCrop = (dataUrl) => applyImage(props.editItem, sourceName.value, dataUrl)

defineExpose({ onActivateCamera })
</script>
<template>
  <div>
    <input
      ref="cameraInput"
      type="file"
      accept="image/*"
      capture="environment"
      style="display:none"
      @change="onFileSelected"
    >
    <input
      ref="galleryInput"
      type="file"
      accept="image/*"
      style="display:none"
      @change="onFileSelected"
    >
    <image-crop-dialog
      v-model="sourceImage"
      @crop="onCrop"
    />
  </div>
</template>
